<app-input-wrapper
  [id]="id() ? id() + '-wrapper' : undefined"
  [titleLabel]="titleLabel()"
  [infoLabel]="infoLabel()"
  [titleIcon]="titleIcon()"
  [style]="style()"
  (titleIconClick)="titleIconClick.emit()"
>
  <mat-form-field [appearance]="appearance()" style="width: 100%">
    <mat-select
      [attr.id]="id()"
      [placeholder]="isLoading() ? loadingText() : placeholder()"
      [disabled]="disabled()"
      [value]="value()"
      (selectionChange)="onSelect($event.value)"
    >
      @for (option of displayOptions; track option) {
        <mat-option [value]="option" [disabled]="option?.__loading">
          {{ getOptionLabel(option) }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</app-input-wrapper>
